/** @format */

import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: inherit;
  position: relative;
  z-index: 0;

  .swiper,
  .swiper-wrapper,
  .swiper-slide {
    min-height: inherit;
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
  }
  .swiper-slide {
    width: 100% !important;
  }

  .swiper-lazy {
    opacity: 0;
    transition: opacity 0.3s;
  }

  .swiper-lazy-loaded {
    opacity: 1;
  }

  .swiper-lazy-preloader {
    border: 0;
  }
`;

export const SwiperPhoto = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const SwiperCounter = styled.div`
  position: absolute;
  z-index: 1;
  right: 1rem;
  bottom: 1rem;
  display: flex;
  padding: 0.125rem 0.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  background: rgba(16, 24, 40, 0.48);

  span {
    color: var(--white, #fff);
    text-align: right;

    font-family: ${({ theme }) => theme.font.body};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 300;
    line-height: 1.25rem;
  }
`;

export const SwiperNavigationButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  opacity: 0;
  background: var(--white, #fff);
  border-radius: 0.5rem;
  border: none;
  outline: none;
  cursor: pointer;

  ${Wrapper}:hover & {
    opacity: 0.86;
    &:hover {
      opacity: 1;
    }
  }

  &:after {
    content: '' !important;
  }
`;

export const SwiperButtonPrev = styled(SwiperNavigationButton)`
  left: 1rem;
  i {
    transform: rotate(180deg);
  }
`;
export const SwiperButtonNext = styled(SwiperNavigationButton)`
  right: 1rem;
`;
